var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAppleMusic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8832 67.3784V42.0629C39.8832 41.1136 40.4039 40.5334 41.4453 40.3225L63.0015 35.8923C64.147 35.6813 64.7718 36.2087 64.8759 37.4745V56.7775C64.8759 58.3598 62.5329 59.4146 57.8467 59.942C48.9431 61.366 50.3489 76.5553 62.5329 72.4415C67.219 70.7011 68 66.1126 68 61.5242V24.5003C68 24.5003 68 21.3359 65.3445 22.127L38.7898 27.6647C38.7898 27.6647 36.7591 27.9812 36.7591 30.5127V62.6317C36.7591 64.214 34.4161 65.2688 29.7299 65.7962C20.8263 67.2202 22.2321 82.4095 34.4161 78.2957C39.1022 76.5553 39.8832 71.9668 39.8832 67.3784Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5B73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC243D"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleMusic);
export default __webpack_public_path__ + "static/media/AppleMusic.124eaacd30e0c22e7fcdfac29f9a3ce9.svg";
export { ForwardRef as ReactComponent };